// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newerror_main_container__rjqXz {
    position: relative;
    height: 100vh;
    background: var(--light-greyish-blue);
    display: flex;
    justify-content: center;
    font-family: Inter, sans-serif;
  }
  .newerror_container__M\\+ajQ {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-top: -50vw;
  }
  .newerror_icon_container__jhp3a {
    position: relative;
    height: 20vw;
    width: 20vw;
    background: var(--light-blue);
    border-radius: 100%;
  }
  .newerror_icon_image__oPdCM {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .newerror_error_heading__6U-v7 {
    font-size: 4.44vw;
    font-weight: 600;
    line-height: 5.37vw;
    text-align: center;
    margin: 3vw 0;
    color: var(--black);
  }
  .newerror_error_title__BJBrJ {
    font-size: 3.33vw;
    font-weight: 500;
    /* line-height: 14.04vw; */
    text-align: center;
    color: var(--grey);
  }
  .newerror_retry_button_container__qXDL4 {
    width: 50.55vw;
    height: 11.66vw;
    border-radius: 40px;
    /* opacity: 0px; */
    background: var(--theme-primary);
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 7vw;
    cursor: pointer;
  }
  .newerror_retry_button_txt__A1yfL {
    font-size: 3.33vw;
    font-weight: 600;
    line-height: 4.03vw;
    text-align: center;
    color: var(--theme-secondary);
  }
  .newerror_headerContainer__6b6fH {
    padding: 20px;
    position: absolute;
    top: 0px;
    left: 0px;
    width: auto;
    z-index: 1;
  }
  .newerror_backBtnBox__94nf3 {
    display: inline-flex;
    align-items: center;
  }
  .newerror_backBtnBox__94nf3 svg {
    width: 20px;
    height: 20px;
  }

  .newerror_makeblock0d0e11__dOjM5 {
    background: #0d0e11;
  }
  .newerror_makeblock0d0e11__dOjM5 .newerror_error_heading__6U-v7{
    color: #fff;
  }
  .newerror_makeblock0d0e11__dOjM5 .newerror_error_title__BJBrJ{
    color: #C1C3CF;
  }

  .newerror_makegreengredient__na004 {
    background: linear-gradient(99deg, rgb(0, 255, 94) 0%, rgb(0, 255, 195) 101.74%);
    color: rgb(13, 14, 17);
    padding: 12px 24px;
    border-radius: 12px;
    border: none;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
  }
  
  @media (min-width: 768px) {
    .newerror_main_container__rjqXz {
      max-width: 500px;
      margin: 0 auto;
      padding: 20px;
    }
    .newerror_container__M\\+ajQ {
      margin-top: -100px;
      width: 100%;
    }
    .newerror_icon_container__jhp3a {
      height: 100px;
      width: 100px;
    }
    .newerror_error_heading__6U-v7 {
      font-size: 24px;
      line-height: 29px;
      margin: 16px 0;
    }
    .newerror_error_title__BJBrJ {
      font-size: 16px;
    }
    .newerror_retry_button_container__qXDL4 {
      width: 100%;
      height: 60px;
      margin-top: 100px;
    }
    .newerror_retry_button_txt__A1yfL {
      font-size: 16px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/ErrorPage/newerror.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,qCAAqC;IACrC,aAAa;IACb,uBAAuB;IACvB,8BAA8B;EAChC;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,6BAA6B;IAC7B,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;EAClC;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;EAC/B;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,UAAU;EACZ;EACA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;;EAEA;IACE,gFAAgF;IAChF,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE;MACE,gBAAgB;MAChB,cAAc;MACd,aAAa;IACf;IACA;MACE,kBAAkB;MAClB,WAAW;IACb;IACA;MACE,aAAa;MACb,YAAY;IACd;IACA;MACE,eAAe;MACf,iBAAiB;MACjB,cAAc;IAChB;IACA;MACE,eAAe;IACjB;IACA;MACE,WAAW;MACX,YAAY;MACZ,iBAAiB;IACnB;IACA;MACE,eAAe;IACjB;EACF","sourcesContent":[".main_container {\n    position: relative;\n    height: 100vh;\n    background: var(--light-greyish-blue);\n    display: flex;\n    justify-content: center;\n    font-family: Inter, sans-serif;\n  }\n  .container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    margin-top: -50vw;\n  }\n  .icon_container {\n    position: relative;\n    height: 20vw;\n    width: 20vw;\n    background: var(--light-blue);\n    border-radius: 100%;\n  }\n  .icon_image {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n  .error_heading {\n    font-size: 4.44vw;\n    font-weight: 600;\n    line-height: 5.37vw;\n    text-align: center;\n    margin: 3vw 0;\n    color: var(--black);\n  }\n  .error_title {\n    font-size: 3.33vw;\n    font-weight: 500;\n    /* line-height: 14.04vw; */\n    text-align: center;\n    color: var(--grey);\n  }\n  .retry_button_container {\n    width: 50.55vw;\n    height: 11.66vw;\n    border-radius: 40px;\n    /* opacity: 0px; */\n    background: var(--theme-primary);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 7vw;\n    cursor: pointer;\n  }\n  .retry_button_txt {\n    font-size: 3.33vw;\n    font-weight: 600;\n    line-height: 4.03vw;\n    text-align: center;\n    color: var(--theme-secondary);\n  }\n  .headerContainer {\n    padding: 20px;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    width: auto;\n    z-index: 1;\n  }\n  .backBtnBox {\n    display: inline-flex;\n    align-items: center;\n  }\n  .backBtnBox svg {\n    width: 20px;\n    height: 20px;\n  }\n\n  .makeblock0d0e11 {\n    background: #0d0e11;\n  }\n  .makeblock0d0e11 .error_heading{\n    color: #fff;\n  }\n  .makeblock0d0e11 .error_title{\n    color: #C1C3CF;\n  }\n\n  .makegreengredient {\n    background: linear-gradient(99deg, rgb(0, 255, 94) 0%, rgb(0, 255, 195) 101.74%);\n    color: rgb(13, 14, 17);\n    padding: 12px 24px;\n    border-radius: 12px;\n    border: none;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n  }\n  \n  @media (min-width: 768px) {\n    .main_container {\n      max-width: 500px;\n      margin: 0 auto;\n      padding: 20px;\n    }\n    .container {\n      margin-top: -100px;\n      width: 100%;\n    }\n    .icon_container {\n      height: 100px;\n      width: 100px;\n    }\n    .error_heading {\n      font-size: 24px;\n      line-height: 29px;\n      margin: 16px 0;\n    }\n    .error_title {\n      font-size: 16px;\n    }\n    .retry_button_container {\n      width: 100%;\n      height: 60px;\n      margin-top: 100px;\n    }\n    .retry_button_txt {\n      font-size: 16px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main_container": `newerror_main_container__rjqXz`,
	"container": `newerror_container__M+ajQ`,
	"icon_container": `newerror_icon_container__jhp3a`,
	"icon_image": `newerror_icon_image__oPdCM`,
	"error_heading": `newerror_error_heading__6U-v7`,
	"error_title": `newerror_error_title__BJBrJ`,
	"retry_button_container": `newerror_retry_button_container__qXDL4`,
	"retry_button_txt": `newerror_retry_button_txt__A1yfL`,
	"headerContainer": `newerror_headerContainer__6b6fH`,
	"backBtnBox": `newerror_backBtnBox__94nf3`,
	"makeblock0d0e11": `newerror_makeblock0d0e11__dOjM5`,
	"makegreengredient": `newerror_makegreengredient__na004`
};
export default ___CSS_LOADER_EXPORT___;
